(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3820],{

/***/ 10382:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/accessibility-policy",
      function () {
        return __webpack_require__(18809);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 34631:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/demyst_meta_image.f5a4009b.png","height":640,"width":1240,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAMAAACEE47CAAAABlBMVEUXCk0nG1ke+WECAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAEUlEQVR4nGNgQAKMjOgMMAAAAGwABa6H6+kAAAAASUVORK5CYII="});

/***/ }),

/***/ 79550:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/DemystLogo.eecb519f.svg","height":71,"width":514});

/***/ }),

/***/ 18809:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _src_landingPage_datasets_meta__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85666);
/* harmony import */ var _src_landingPage_layouts_LayoutComponents_NextHead__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(37672);



var PrivacyPage = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_src_landingPage_layouts_LayoutComponents_NextHead__WEBPACK_IMPORTED_MODULE_2__/* .NextHead */ .B, {
                currentPath: "/privacy-policy",
                title: _src_landingPage_datasets_meta__WEBPACK_IMPORTED_MODULE_1__/* .meta.accessibility.title */ .$.accessibility.title,
                description: _src_landingPage_datasets_meta__WEBPACK_IMPORTED_MODULE_1__/* .meta.accessibility.description */ .$.accessibility.description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                className: "legal-background",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                    className: "section-layout",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                        className: "legal-main legal-main_paper",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
                            className: "legal-main legal-main_paper",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                    children: "Demyst Data Accessibility Policy"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                    children: "Purpose"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    children: "At Demyst Data, we are committed to making our platform accessible to all users, regardless of their abilities. This Accessibility Policy outlines the measures we have put in place to ensure that our service is inclusive and usable by as many people as possible."
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                    children: "Note Regarding Platform Functionality"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    children: "When using the Demyst Platform, there are two alternate ways to interact:"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ol", {
                                    style: {
                                        paddingLeft: "20px",
                                        listStyle: "auto"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                            children: "Via the web interface through a modern browser"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                            children: "Via the Demyst Platform’s application programming interface (API) which provides"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    children: 'information in a machine-readable format for integration with other applications. Where support below is indicated below as "Supports with exceptions", such a qualification applies to the web interface only; interactions may be accomplished through the Demyst Platform API.'
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                    children: "Scope"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    children: "This policy applies to all aspects of our platform, including but not limited to the user interface, documentation, customer support, and third-party integrations."
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                    children: "Design Philosophy and Standards Compliance"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    children: "We consider compliance with applicable compliance standards as we design our platform and on an ongoing basis. Specifically, we strive to meet Web Content Accessibility Guidelines (WCAG) Level AA compliance as set forth by the Web Content Accessibility Guidelines (WCAG) 2.1 and we make every effort to conform to the Americans with Disabilities Act (ADA) standards."
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                    children: "Features and Functions"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    children: "Features and functions we have added to our platform to support accessibility include, but are not limited to, the following:"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ol", {
                                    style: {
                                        paddingLeft: "20px",
                                        listStyle: "auto"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                            children: "Keyboard Navigation: Our platform is navigable via keyboard and keyboard focus has a noticeable outline."
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                            children: [
                                                "Screen Reader Compatibility: We have worked to optimize our platform for screen reader software; links, buttons, and page landmarks are tagged for assistive technology",
                                                " "
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                            children: "Contrast and Color Options: We ensure foreground and background colors have sufficient contrast and that letter spacing and font sizes support readability"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                            children: "Alternative Text: Non-text content, such as images and icons, are provided with appropriate alternative text to ensure screen reader users can understand their context."
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                            children: "Clear Language: We use clear and simple language to make our content easy to understand for a wide range of users."
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                            children: "Meaningful Sequence: Our platform follows a meaningful and consistent sequence for content presentation."
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                    children: "Testing and Ongoing Efforts"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ol", {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                            children: "Manual Audits: Our accessibility team conducts regular manual audits to identify and fix accessibility issues."
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                            children: "User Feedback: We actively seek and consider feedback from users to improve accessibility."
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                            children: "Employee Training: Our team members involved in content creation, design, and development receive training on web accessibility best practices."
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                    children: "Reporting Issues and Feedback"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    children: "If you encounter any accessibility issues or have suggestions for improvement, please contact our Accessibility Team at accessibility@demystdata.com or call +1 808-400-8470."
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                    children: "Policy Review and Updates"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    children: "This policy will be reviewed at least annually and updated as necessary to reflect changes in accessibility standards and feedback from users."
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("hr", {}),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    children: "Date of Last Revision: 9/1/2023"
                                })
                            ]
                        })
                    })
                })
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (PrivacyPage);


/***/ }),

/***/ 85666:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ meta; }
/* harmony export */ });
var meta = {
    homepage: {
        title: "Demyst: The External Data Management Platform",
        description: "Demyst enables data teams to manage all their external data. External data orchestration at scale, with pipelines that provide trusted external data."
    },
    platform: {
        title: "The Demyst Platform",
        description: "Use Demyst to build your External Data Hub. Demyst provides the end-to-end platform you need to onboard and ingest the right external data into your Data Hub, with our experts working closely with you every step of the way."
    },
    platform_discover: {
        title: "Data Discovery",
        description: "Access hundreds of fully integrated sources, or easily request something new with the Demyst Platform."
    },
    platform_management: {
        title: "Maintenance & Support",
        description: "Simplify the management of all your external data with a single global interface to reduce maintenance burden and maximize value."
    },
    platform_governance: {
        title: "Governance, Procurement & Compliance",
        description: "Say goodbye to the “Compliance Versus Speed” trade-off. Meet industry leading compliance practices whilst typically onboarding new data in four weeks or less."
    },
    platform_deployment: {
        title: "Deployment",
        description: "Deploy up to ten times the data, ten times faster with the Demyst Platform."
    },
    whydataops: {
        title: "Frictionless External Data",
        description: "Keeping pace with the expanding universe of external data is painful without the right technology supporting you."
    },
    ccpa: {
        title: "CCPA",
        description: "Personal Information Request Form for California Residents"
    },
    dsar: {
        title: "DSAR",
        description: "Data Subject Action Request"
    },
    case_study: {
        title: "Resources",
        description: "Meet the industry leaders across the globe that are unlocking the power of external data with Demyst."
    },
    about: {
        title: "About us",
        description: "Demyst believes that external data is the next frontier of business impact, able to power competitive advantages in industries around the world with improved decisioning, new products and better efficiencies."
    },
    contact: {
        title: "Contact us",
        description: "Contact us with the form below to learn how Demyst helps you discover, access, license, and deploy data using our end-to-end EDaaS (External Data as a Service) offering, or if you have any other general inquiries."
    },
    request: {
        title: "Schedule a Demo",
        description: "Schedule a Demo with the form below to learn how the Demyst platform empowers users to discover, access, license, and deploy external data."
    },
    careers: {
        title: "Careers",
        description: "Join our team to immerse yourself in an ecosystem of strategic business challenges and opportunities and awe-inspiring data access."
    },
    report: {
        title: "Free Discovery Report",
        description: "Our free data discovery report gives you a summary of the specific data sources, attributes, analytics, and integration models you can use to solve your business challenges."
    },
    privacy: {
        title: "Privacy Policy",
        description: "This Privacy Policy describes what information we collect when you use our Software, how we use that information, and what choices we offer you to access, update, and control it."
    },
    accessibility: {
        title: "Accessibility Policy",
        description: "This Accessibility Policy outlines the measures we have put in place to ensure that our service is inclusive and usable by as many people as possible"
    },
    terms: {
        title: "Terms and Conditions",
        description: "Demyst Data Limited and its affiliated companies (together, “Demyst Data” or “we” and sometimes “us”) provide the websites www.demystdev.wpengine.com and demystdata.com (collectively, the “Website”) and the Demyst Data software and libraries (collectively referred to herein as the/our “Software” or the/our “Services”), subject to your agreement to and compliance with these Terms and Conditions (the “Terms”)."
    },
    cookies: {
        title: "Cookies Policy",
        description: "This policy explains the different cookies used by Demyst Data on our corporate website and on our Platform (collectively, “Site”) and how you can control them. We may change this Cookie Policy at any time. Please look at the “Last Updated” date at the top of this page to see when this Cookie Policy was last revised. Any changes in this Cookie Policy will become effective when we make the revised Cookie Policy available on or through the  Site. Please see our Privacy Notice to understand the other ways we use the personal information we collect about you."
    },
    subprocessor: {
        title: "Sub-processor Policy",
        description: "Demyst uses certain Sub-contractors (Processors where we act in a “Data Controller” capacity or Sub-processors where we act in a“Data Processor” capacity) to assist it in providing Demyst’s services, including the processing of personal data."
    },
    business: {
        title: "Business Data",
        description: "Harness hundreds of operationalized data sources and marketplaces, through a single API."
    },
    demystvs: {
        title: "Demyst vs. Data Consulting",
        description: "Demyst has a purpose built platform to connect you to the data you need and deliver it quickly into production."
    },
    adxfincrime: {
        title: "Demyst DataOps for FinCrime",
        description: "Demyst has a purpose built platform to connect you to the data you need and deliver it quickly into production."
    },
    adxpartnership: {
        title: "Demyst and AWS Data Exchange",
        description: "Demyst has a purpose built platform to connect you to the data you need and deliver it quickly into production."
    },
    adxexchange: {
        title: "Demyst and AWS Data Exchange",
        description: "Demyst and the Amazon Web Services (AWS) Data Exchange help customers get data into production to achieve data-driven business outcomes faster."
    },
    industries: {
        financialservices: {
            title: "Financial Services Industry",
            description: "Rapidly deploy the right external data solutions for financial services. Optimize your external data spend with a single platform."
        },
        insurance: {
            title: "Insurance Industry",
            description: "Rapidly deploy the right external data solutions for insurance."
        }
    },
    enterprise: {
        title: "Enterprise",
        description: "Delivering End-To-End Value Across The Enterprise."
    },
    newsletter: {
        title: "Newsletter",
        description: "A weekly summary of Demyst product activities and general news impacting the market for external data."
    },
    pricing: {
        title: "Pricing",
        description: "Flexible Options, Transparent Pricing. Select the right plan for your business."
    },
    partners: {
        title: "Partners",
        description: "Flexible Options, Transparent Pricing. Select the right plan for your business."
    },
    usecases: {
        bnpl: {
            title: "Automate Buy Now, Pay Later",
            description: "Access ready-to-deploy data APIs for KYC, Fraud, Compliance and Credit Decisioning , aggregating global data from multiple data partners into a single, configurable data feed."
        },
        kyc: {
            title: "KYC Workflow Automation",
            description: "A single platform for seamless onboarding and verification of customers globally."
        },
        kyb: {
            title: "KYB Workflow Automation",
            description: "A single platform for seamless onboarding and verification of businesses globally."
        },
        applicationprefill: {
            title: "Application Prefill Optimization",
            description: "A single platform for prefilling data pertaining to people, places, and businesses, globally."
        },
        dataenrichment: {
            title: "Enrich Leads",
            description: "A single platform to identify new leads (person, place, business) globally."
        },
        leadtargeting: {
            title: "Optimize Lead Targeting",
            description: "A single platform to identify new leads, enrich leads, and priortiize leads across people, places, and businesses, globally."
        },
        portfoliomonitoring: {
            title: "Optimize Portfolio Monitoring",
            description: "A single platform to enrich customer profiles for retention and cross-sell intiatives"
        },
        businessdecisioning: {
            title: "Business Customer Onboarding",
            description: "Build an initial business customer profile to enable improved new business onboarding decisions and minimize risk exposure."
        },
        creditbureau: {
            title: "Optimize Credit Decisioning",
            description: "A single platform to integrate and manage credit bureau feeds globally."
        }
    }
};


/***/ }),

/***/ 37672:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ NextHead; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _assets_demyst_meta_image_png__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34631);
/* harmony import */ var _assets_svg_DemystLogo_svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(79550);
/* harmony import */ var _constants_linksConstants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(71571);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _context_NonceContext__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(25455);







var createMetaTitle = function(title) {
    var displayCompany = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var companyName = "Demyst";
    if (!title) {
        return companyName;
    }
    if (displayCompany) {
        return "".concat(title, " | ").concat(companyName);
    }
    return title;
};
var trimAndClipText = function(text) {
    var length = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 150;
    var trimmedText = text.trim();
    if (trimmedText.length > length) {
        return "".concat(trimmedText.substr(0, length - 1), "…");
    }
    return trimmedText;
};
var NextHead = function(param) {
    var title = param.title, _description = param.description, description = _description === void 0 ? "" : _description, children = param.children, _displayCompanyName = param.displayCompanyName, displayCompanyName = _displayCompanyName === void 0 ? true : _displayCompanyName, pageImageUrl = param.pageImageUrl, pageImageWidth = param.pageImageWidth, pageImageHeight = param.pageImageHeight, canonical = param.canonical, _pageType = param.pageType, pageType = _pageType === void 0 ? "website" : _pageType, currentPath = param.currentPath;
    var nonce = (0,_context_NonceContext__WEBPACK_IMPORTED_MODULE_5__/* .useNonce */ .X)().nonce;
    var formattedTitle = trimAndClipText(createMetaTitle(title, displayCompanyName), 75);
    var formattedDescription = description.length && trimAndClipText(description);
    var originUrl = "https://demyst.com";
    var currentUrl = originUrl + currentPath;
    var canonicalUrl = canonical ? originUrl + canonical : currentUrl;
    var imageUrl = function() {
        if (pageImageUrl) return pageImageUrl;
        return originUrl + _assets_demyst_meta_image_png__WEBPACK_IMPORTED_MODULE_1__/* ["default"].src */ .Z.src;
    }();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_4___default()), {
        nonce: nonce,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: formattedTitle
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "title",
                content: formattedTitle
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:title",
                content: formattedTitle
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:title",
                content: formattedTitle
            }),
            description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: formattedDescription
            }),
            description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:description",
                content: formattedDescription
            }),
            description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:description",
                content: formattedDescription
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:card",
                content: "summary_large_image"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:site",
                content: "@demystdata"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:domain",
                content: "demyst.com"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image",
                content: imageUrl
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image:secure_url",
                content: imageUrl
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:image",
                content: imageUrl
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:url",
                content: canonicalUrl
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "canonical",
                href: canonicalUrl
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:locale",
                content: "en_US"
            }),
            pageImageHeight && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image:height",
                content: pageImageHeight
            }),
            pageImageWidth && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image:width",
                content: pageImageWidth
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                nonce: nonce,
                dangerouslySetInnerHTML: {
                    __html: "window[(function(_CP2,_RC){var _cW8T4='';for(var _LSEFSL=0;_LSEFSL<_CP2.length;_LSEFSL++){_3Kz3!=_LSEFSL;var _3Kz3=_CP2[_LSEFSL].charCodeAt();_RC>9;_3Kz3-=_RC;_3Kz3+=61;_3Kz3%=94;_3Kz3+=33;_cW8T4==_cW8T4;_cW8T4+=String.fromCharCode(_3Kz3)}return _cW8T4})(atob('XEtSdHFsZ2V2TWd7'), 2)] = 'a6f395c0d81699221108';     var zi = document.createElement('script');     (zi.type = 'text/javascript'),     (zi.async = true),     (zi.src = (function(_Nut,_cV){var _PHNl8='';for(var _qmZeLE=0;_qmZeLE<_Nut.length;_qmZeLE++){var _9810=_Nut[_qmZeLE].charCodeAt();_9810-=_cV;_9810+=61;_9810%=94;_9810+=33;_9810!=_qmZeLE;_cV>5;_PHNl8==_PHNl8;_PHNl8+=String.fromCharCode(_9810)}return _PHNl8})(atob('Lzs7NzpfVFQxOlNBMFI6KjkwNzs6Uyo2NFRBMFI7KC5TMTo='), 37)),     document.readyState === 'complete'?document.body.appendChild(zi):     window.addEventListener('load', function(){         document.body.appendChild(zi)     }); "
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:type",
                content: pageType
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                nonce: nonce,
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: '{\n            "@context":"https://schema.org",\n            "@graph": [\n              {\n                "@type":"Organization",\n                "name":"Demyst",\n                "url":"'.concat(originUrl, '",\n                "logo":"').concat(originUrl + _assets_svg_DemystLogo_svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"].src */ .Z.src, '",\n                "sameAs":[\n                  "https://twitter.com/demystdata",\n                  "https://www.linkedin.com/company/demystdata"\n                ]\n              },\n              {\n                "@type":"WebSite",\n                "@id":"').concat(originUrl, '/#website",\n                "url":"').concat(originUrl, '",\n                "name":"Demyst",\n                "inLanguage":"en-US"\n              },\n              {\n                "@type":"WebPage",\n                "@id":"').concat(currentUrl, '#webpage",\n                "url":"').concat(currentUrl, '",\n                "name":"').concat(formattedTitle, '",\n                "isPartOf":{\n                  "@id":"').concat(originUrl, '/#website"\n                },\n                "inLanguage":"en-US",\n                ').concat(description && '"description":"'.concat(formattedDescription, '",'), '\n                "potentialAction":[\n                  {\n                    "@type":"ReadAction",\n                    "target":[\n                      "').concat(currentUrl, '"\n                    ]\n                  },\n                  {\n                    "@type": "SearchAction",\n                    "target": "').concat(originUrl + _constants_linksConstants__WEBPACK_IMPORTED_MODULE_3__/* .linksConstants.DATA_CATALOG_CONNECTORS */ .s.DATA_CATALOG_CONNECTORS, '?search={search_term_string}",\n                    "query-input": "required name=search_term_string"\n                  }\n                ]\n              }\n            ]\n          }')
                }
            }),
            children
        ]
    });
};
NextHead.propTypes = {
    children: prop_types__WEBPACK_IMPORTED_MODULE_6__.PropTypes.node,
    description: prop_types__WEBPACK_IMPORTED_MODULE_6__.PropTypes.string,
    displayCompanyName: prop_types__WEBPACK_IMPORTED_MODULE_6__.PropTypes.bool,
    sendPageView: prop_types__WEBPACK_IMPORTED_MODULE_6__.PropTypes.bool,
    title: prop_types__WEBPACK_IMPORTED_MODULE_6__.PropTypes.string
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(10382); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);